<script lang="ts">
  import Flash from '#app/lib/components/flash.svelte'
  import type { FlashState } from '#app/lib/components/flash.svelte'
  import { icon } from '#app/lib/icons'
  import EntityValueDisplay from '#entities/components/editor/entity_value_display.svelte'
  import EntityAutocompleteSelector, { type EntityAutocompleteSuggestion } from '#entities/components/entity_autocomplete_selector.svelte'
  import type { SerializedEntity } from '#entities/lib/entities'
  import { typesBySection } from '#search/lib/search_sections'
  import type { EntityUri, ExtendedEntityType } from '#server/types/entity'
  import { I18n } from '#user/lib/i18n'
  import type { SearchableType } from '../lib/search/type_search'

  let {
    type = $bindable(),
    uri = $bindable(),
  }: {
    type: ExtendedEntityType
    uri: EntityUri
  } = $props()

  let flash: FlashState | undefined = $state()
  let valueBasicInfo: SerializedEntity | undefined = $state()
  let editMode = $state(false)

  function select (suggestion: EntityAutocompleteSuggestion) {
    uri = suggestion.uri
    editMode = false
  }

  function setInfo () {
    type = valueBasicInfo.type
    // TODO: figure-out if this is dead code as the redirection attribute doesn't seem to exist
    if (uri && 'redirection' in valueBasicInfo) {
      uri = valueBasicInfo.redirection as EntityUri
    }
  }

  const searchTypes = $derived(type ? [ type ] : [ 'edition', ...typesBySection.entity.all ] as SearchableType[])

  $effect(() => {
    if (valueBasicInfo) setInfo()
  })
</script>

{#if uri && !editMode}
  <div class="row">
    <EntityValueDisplay
      value={uri}
      bind:valueBasicInfo
      onEdit={() => editMode = true}
    />
    <button
      class="unselect"
      title={I18n('unselect')}
      onclick={() => uri = null}
    >
      {@html icon('close')}
    </button>
  </div>
{:else}
  <EntityAutocompleteSelector
    {searchTypes}
    currentEntityUri={uri}
    currentEntityLabel={uri ? valueBasicInfo?.label : null}
    displaySuggestionType={type == null}
    autofocus={false}
    onClose={() => editMode = false}
    onError={err => flash = err}
    onSelect={select}
  />
{/if}

<Flash bind:state={flash} />

<style lang="scss">
  @import "general/scss/utils";
  .row{
    @include display-flex(row, center);
  }
  .unselect{
    @include shy;
    :global(.fa){
      font-size: 1.2rem;
    }
  }
</style>
